import Axios from "../api/axios";
import config from "../../config";

const previewLetterPdf = (token, updateData) => {
  const payload = Object.entries(updateData).reduce((acc, [key, value]) => {
    if (value !== null) {
      acc[key] = value;
    }
    return acc;
  }, {});

  return Axios.post(`${config.BASE_URL}preview-letter-pdf`, payload, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
    responseType: 'blob',   // ⭐⭐⭐ REQUIRED FOR PDF
  });
};

export default previewLetterPdf;
